DialogInformesAddAInformeCtrl.$inject = ['$log', '$scope', '$http', '$q'];
export default function DialogInformesAddAInformeCtrl($log, $scope, $http, $q) {
    let urlBase = Sigo.url + '/api/v1/informes';
    let vm = this;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = false;
    vm.model = {
        titulo: "",
        informe_id: null
    };

    let grafico = $scope.model;

    vm.model.titulo = grafico.titulo;
    vm.informes = [];

    cargarInformes();

    vm.canSubmit = function () {
        if (vm.model.informe_id == null) return false;

        return true;
    };

    vm.addGrafico = function() {
        if (!vm.canSubmit()) return;
        let informeId = vm.model.informe_id;
        let url = urlBase + '/' + informeId + '/graficos';
        let data = {
            titulo: vm.model.titulo !== "" ? vm.model.titulo : null,
            tipo: grafico.tipo,
            grafico_id: grafico.id,
            parametros: grafico.parametros
        };
        vm.cargando = true;
        let promesa = $http.post(url, data);
        promesa.then(function () {
            let urlInforme = Sigo.var.path + '/estadisticas/informes/detail/' + informeId;
            Sigo.UI.Toast.success('', Lang.get('estadisticas.dialgo_add_grafico_informe_ok')
                + ' <a href="' + urlInforme + '" target="_blank">' + ucfirst(Lang.get('estadisticas.ver_informe'))
                + '</a>.');
            vm.dialogHandler.close();
            vm.cargando = false;
        }, () => {
            vm.cargando = false;
        });
        return promesa;
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    };

    function cargarInformes() {
        let defered = $q.defer();
        let promesa = $http.get(urlBase + '/editables');
        vm.cargando = true;
        promesa.then((respuesta) => {
            defered.resolve(respuesta.data);
            vm.informes = respuesta.data;
            vm.cargando = false;
        }, () => {
            $log.error('Error');
            defered.reject([]);
            vm.informes = [];
            vm.cargando = false;
        });
        return defered.promise;
    }
}